module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("CONTENTS")])]), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/04_Chapter01"
    }
  }, [_vm._v("Arthur Christmas")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Chapter02"
    }
  }, [_vm._v("Bad Santa")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Chapter03"
    }
  }, [_vm._v("Batman Returns")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Chapter04"
    }
  }, [_vm._v("Bridget Jones’s Diary")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Chapter05"
    }
  }, [_vm._v("Christmas Animations")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Deck the Halls")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Die Hard")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Doctor Who Christmas Specials")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Edward Scissorhands")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elf")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Frozen")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gremlins")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Grinch")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Harry Potter")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Holiday")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Home Alone")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("It’s a Wonderful Life")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jack Frost")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James Bond")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jingle All the Way")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Klaus")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Krampus")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Last Christmas")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Love Actually")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Miracle on 34th Street")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Muppet Christmas Carol")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("National Lampoon’s Christmas Vacation")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Nightmare Before Christmas")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Polar Express")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Princess Switch")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Santa Clause")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scrooged")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Chapter33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shaun the Sheep: The Flight Before Christmas")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Shrek")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Chapter35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Snowman")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Chapter36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Star Wars Movies")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Chapter37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Star Wars Holiday Special")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Chapter38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Trading Places")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42_Chapter39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("While You Were Sleeping")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/43_Chapter40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("White Christmas")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Chapter41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Answers")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/45_About_the_Author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ee5fb14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 66
// module chunks = 0